<ng-template #accountMenu>
    <!-- Not logged in -->
    <a *ngIf="!(customer$ | async)" class="dropdown-item"
       (click)="toggleLoginRegister(); showAccountMenuMobile = false">
        Anmelden, Registrieren
    </a>
    <div *ngIf="(customer$ | async)?.id && !(customer$ | async)?.guest">
        <a routerLink="/user/data" class="dropdown-item">
            Benutzername & E-Mail
        </a>
        <a routerLink="/user/password-update" class="dropdown-item">
            Passwort ändern
        </a>
        <hr class="dropdown-divider">
        <a routerLink="/customer/data" class="dropdown-item">
            Kundendaten
        </a>
        <a routerLink="/customer/orders" class="dropdown-item">
            Bestellungen
        </a>
        <a *ngIf="isAccess('invoices')" routerLink="/customer/invoices" class="dropdown-item">
            Rechnungen
        </a>
        <hr class="dropdown-divider">
        <a class="dropdown-item"
           (click)="setLogout(); showAccountMenu = false; showAccountMenuMobile = false;">
            <fa-icon [icon]="faSignOut"></fa-icon>
            <span class="is-inline-block ml-1">Abmelden</span>
        </a>
    </div>
    <!-- Guest -->
    <div *ngIf="(customer$ | async)?.guest">
        <a class="dropdown-item"
           (click)="setLogout(); showAccountMenu = false; showAccountMenuMobile = false;">
            <fa-icon [icon]="faSignOut"></fa-icon>
            Gastsitzung beenden
        </a>
    </div>

</ng-template>
<header>
    <div id="header-container" [ngClass]="showMenuMobile ? 'open-menu' : ''">
        <div id="header">
            <div class="container-inner">
                <!--<a href="shop/whisky-und-gin" class="novelty"><img src="./assets/design/alpgin.svg"></a>-->
                <a routerLink="/" class="logo" aria-label="Zur Startseite"><img src="./assets/design/header_logo.jpg"
                                                                                alt=""/></a>
                <a (click)="showMenuMobile = !showMenuMobile" class="mobile-menu"><img
                        class="link-open" src="./assets/design/icons/mobile-menu.svg" alt=""/><span
                        class="link-close">X</span></a>
                <div id="der-shop"></div>
                <!--  <div id="hotline"  >
                      <span class="is-flex">


                      </span>
                  </div>-->
            </div>
        </div>
        <div id="head-menu-container">
            <div class="container-inner">
                <div class="products drop-down-toggle" [ngClass]="showMenu ? 'active' : ''"><a class="is-pointer"
                                                                                               (click)="showMenu=!showMenu"
                                                                                               (clickOutside)="showMenu=false">Produkte
                    <fa-icon [icon]="faAngleDown" [ngClass]="showMenu ? 'is-hidden' : ''"></fa-icon>
                    <fa-icon [icon]="faAngleUp" [ngClass]="!showMenu ? 'is-hidden' : ''"></fa-icon>

                </a>
                    <div class="submenu">
                        <a routerLink="/shop/schnaepse-und-alte-milde"
                           (click)="showMenu = false; showMenuMobile =false; resetSearch()">Schnäpse & Alte Milde</a>
                        <a routerLink="/shop/obstbraende-und-geiste"
                           (click)="showMenu = false; showMenuMobile =false; resetSearch()">Obstbrände & Geiste</a>
                        <a routerLink="/shop/likoere-und-limes"
                           (click)="showMenu = false; showMenuMobile =false; resetSearch()">Liköre & Limes</a>
                        <a routerLink="/shop/whisky-rum-und-gin"
                           (click)="showMenu = false; showMenuMobile =false; resetSearch()">Whisky, Rum & Gin</a>
                        <a routerLink="/shop/selection-45"
                           (click)="showMenu = false; showMenuMobile =false; resetSearch()">Selection
                            45</a>
                        <a routerLink="/shop/enzian-baer-und-blutwurz"
                           (click)="showMenu = false; showMenuMobile =false; resetSearch()">Enzian, Bär- & Blutwurz</a>
                        <a routerLink="/shop/geschenk-ideen-und-gutscheine"
                           (click)="showMenu = false; showMenuMobile =false; resetSearch()">Geschenk-Ideen &
                            Gutscheine</a>
                        <a routerLink="/shop/glaeser-und-co"
                           (click)="showMenu = false; showMenuMobile =false; resetSearch()">Gläser & Co.</a>
                        <a routerLink="/shop/saisonale-gaumenfreuden"
                           (click)="showMenu = false; showMenuMobile =false; resetSearch()">Saisonale Gaumenfreuden</a>
                        <a routerLink="/shop/:" (click)="showMenu = false; showMenuMobile =false; resetSearch()">Alle
                            Produkte ansehen</a>
                    </div>
                </div>
                <form [formGroup]="form">
                    <div class="search">
                        <div class="form-group visible-xs">
                            <input id="searchString" type="text" class="form-control search-article"
                                   formControlName="searchString"
                                   placeholder="Suchbegriff eingeben..." aria-label="Suche starten">
                            <button href="#" aria-label="Suche starten" type="submit"><img
                                    src="./assets/design/icons/search.svg" alt=""/></button>
                        </div>
                    </div>
                </form>
                <div class="button dropdown is-custom-1 pb-0 pt-0 " [ngClass]="showAccountMenu ? 'is-active' : ''">
                    <a class="dropdown-trigger item is-size-7-desktop pt-2-touch px-2 is-block-touch has-text-centered"
                       (click)="showAccountMenu = !showAccountMenu; resetSearch()"
                       (clickOutside)="showAccountMenu = false">
                        <img src="./assets/design/icons/account.svg" alt=""
                             [ngClass]="showAccountMenu ? 'is-hidden' : ''"/>
                        <img src="./assets/design/icons/account-brown.svg" alt=""
                             [ngClass]="!showAccountMenu ? 'is-hidden' : ''"/><br>
                        <span class="my-account-name is-block">{{ myAccount }}</span>
                    </a>
                    <div class="dropdown-menu has-text-left">
                        <div class="dropdown-content is-size-4">
                            <ng-container *ngTemplateOutlet="accountMenu"></ng-container>
                        </div>
                    </div>
                </div>
                <!--<div class="button"><a href="account"><img src="./assets/design/icons/account.svg"/><br>Mein
                    Konto</a></div>-->
                <div class="button"><a routerLink="/customer/favorites"><img
                        src="./assets/design/icons/favorites.svg" alt=""/><br>Wunschzettel</a></div>
                <div class="button"><a routerLink="/cart" (click)="resetSearch()" id="shopping-cart"><img
                        src="./assets/design/icons/cart.svg" alt=""/><br>Einkaufswagen

                    <span id="iw-shopping-cart-overview"><span *ngIf="articlesInCart"
                                                               class="amount">{{ articlesInCart }}</span></span></a>
                </div>
                <div class="button"><a href="https://www.allgaeu-brennerei.de/"><img
                        src="./assets/design/icons/home.svg" alt=""/><br>Zur Brennerei</a></div>
            </div>
        </div>
    </div>
</header>
<main>
    <div id="content">
        <div class="container-inner">
            <div class="col-12 pb-6">
                <div class="col-12 p-0">
                    <div *ngIf="(breadcrumb | async)?.level1?.name" class="row">
                        <div id="breadcrumb-container" class="col-12">
                            <a routerLink="/">Home</a>
                            <p><b> | </b></p>
                            <a *ngIf="(breadcrumb | async)?.level1?.routerLink && !(breadcrumb | async)?.level2?.name"><span>{{ (breadcrumb | async)?.level1?.name }}</span></a>

                            <a *ngIf="(breadcrumb | async)?.level1?.routerLink && (breadcrumb | async)?.level2?.name"
                               [routerLink]="(breadcrumb | async)?.level1?.routerLink"
                               [queryParams]="(breadcrumb | async)?.level1?.routerQueryParams"
                               [fragment]="(breadcrumb | async)?.level1?.routerFragment ?? ''"><span>{{ (breadcrumb | async)?.level1?.name }}</span></a>

                            <p *ngIf="!(breadcrumb | async)?.level1?.routerLink">{{ (breadcrumb | async)?.level1?.name }}</p>
                            <p *ngIf="(breadcrumb | async)?.level2?.name">
                                <span><b>|</b> {{ (breadcrumb | async)?.level2?.name }}</span>
                            </p>
                        </div>
                    </div>
                    <div class=" is-hidden-touch is-flex align-items-center is-size-5 is-justify-content-right mb-5"
                         [ngClass]="((breadcrumb | async)?.level1?.name) ? '' : 'mt-5'">
                        <div class="py-2 px-4 is-inline-block has-background-brown">
                            <span class=" has-text-white is-size-6">Bestell-Hotline: 08376 929 920 </span>
                            <a class=" ml-2" href="https://www.facebook.com/allgaeubrennereisulzberg"
                               target="_blank"><img
                                    ngSrc="./assets/design/icons/facebook.svg" height="25" width="25"
                                    alt="Facebook"/></a>
                            <a class=" ml-2" href="https://www.instagram.com/allgaeubrennerei_sulzberg/"
                               target="_blank"><img
                                    ngSrc="./assets/design/icons/instagram.svg" height="25" width="25"
                                    alt="Twitter"></a>
                        </div>

                    </div>
                </div>
                <ng-content></ng-content>
            </div>
        </div>

    </div>
</main>
<footer>
    <div class="newsletter-container">
        <div class="col-12">
            <div class="container-inner">
                <div class="row">
                    <div class="col-12 col-md-8"><h2>Newsletter-Anmeldung</h2>
                        <p class="info">Sie möchten über neue Produkte, aktuelle Angebote und Neuigkeiten aus unserer
                            Genusswerkstatt informiert werden?<br>Dann melden Sie sich gleich hier zu unseren Newsletter
                            an!</p>
                        <div class="spacer"></div>
                        <div class="newsletter-form"></div>
                        <!--<h2>Newsletter-Anmeldung</h2><p>Sie möchten über neue Produkte, aktuelle Angebote und Neuigkeiten aus unserer Genusswerkstatt informiert werden?<br>Dann melden Sie sich gleich hier zu unseren Newsletter an!</p><div class="spacer"></div><form class="iw-action-submit" iw-options='{"action":"sendForm", "reloadOnSuccess": "false"}' action="newsletter2go?output=json"><div class="row"><div class="col-12 col-sm-auto "><label>E-Mail-Adresse:</label></div><div class="col-12 col-sm-auto input-container"><input type="email" name="email" class="form-control email" ></div></div><div class="spacer"></div><div class="checkbox"><label><input type="checkbox" value="" required>Ich bestätige die <a href="https://www.newsletter2go.de/datenschutz/" target="_blank" class="link">Datenschutzbestimmung</a></label></div><div class="spacer"></div><div class="row"><div class="col-12"><p>Wir nutzen Newsletter2Go als Dienstleister für die Versendung unserer Newsletter. Im Rahmen dieser Anmeldung erklären Sie sich einverstanden, dass Ihre eingegebenen Daten an Newsletter2Go übermittelt werden. Bitte beachten Sie die <a href="https://www.newsletter2go.de/datenschutz/" class="link" target="_blank">Datenschutzbestimmung</a> und <a href="https://www.newsletter2go.de/agb/" target="_blank" class="link">Allgemeinen Geschäftsbedingungen</a> von Newsletter2Go.</p></div></div><div class="spacer"></div><div class="row"><div class="col-12"><button type="submit"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24.257"><defs><style>.a{fill:#fff;}.b{fill:none;}</style></defs><g transform="translate(0 0)"><path class="a" d="M2.01,21.193,23,12.1,2.01,3,2,10.075,17,12.1,2,14.118Z" transform="translate(0 0.032)"/><path class="b" d="M0,0H24V24.257H0Z"/></g></svg>Abschicken</button></div></div></form>-->
                        <div class="spacer"></div>
                    </div>
                    <div class="col-12 col-md-4 image-container"><img
                            src="./assets/design/foot_brennerei.png" alt=""/></div>
                </div>
            </div>
        </div>
    </div>

    <div class="foot-container col-12">
        <div class="container-inner">
            <div class="row">
                <div class="col-12 col-sm-6">
                    <div class="box"><a href="https://www.allgaeu-brennerei.de/impressum/" target="_blank" class="link">Impressum</a><a
                            href="https://www.allgaeu-brennerei.de/datenschutz/" target="_blank" class="link">Datenschutz</a><a
                            href="https://www.allgaeu-brennerei.de/agb/" target="_blank" class="link">AGB</a><a
                            href="https://www.allgaeu-brennerei.de/metanavigation/barrierefreiheit/" target="_blank" class="link">Barrierefreiheit</a><a
                            href="https://www.allgaeu-brennerei.de/widerruf/" target="_blank"
                            class="link">Widerruf</a><a href="https://www.allgaeu-brennerei.de/ueber-uns/kontakt/"
                                                        target="_blank"
                                                        class="link">Kontakt</a>
                        <button class="withdrawel-button button is-fullwidth is-block is-primary mt-3 mb-2 is-uppercase" style="max-width:250px;" (click)="scrollToTop()" routerLink="/vertrag-widerrufen">Vertrag widerrufen</button>

                        <div class="social-media"><a href="https://www.facebook.com/allgaeubrennereisulzberg" aria-label="Zu Facebook"
                                                     target="_blank"><img
                                src="./assets/design/icons/fb.png" class="fb" alt=""/></a><a
                                href="https://www.instagram.com/allgaeubrennerei_sulzberg/"  aria-label="Zu Instagram" target="_blank"><img
                                src="./assets/design/icons/instagram.png" class="instagram" alt=""/></a>
                        </div>
                        <p>Allgäu-Brennerei<br>Gewerbepark 1<br>87477 Sulzberg<br>Tel 08376 929 920<br><b>info&#64;allgaeu-brennerei.de</b>
                        </p>
                        <p class="price-mode">Alle Preise inkl. MwSt.</p></div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="payment-methods"><p class="bold">Zahlungsmöglichkeiten</p>
                        <img
                                class="paypal" src="./assets/design/paypal.jpg" alt=""/><br>
                        <img class="paypal" src="./assets/design/klarna.png" alt=""><br>

                        <img class="creditcard"
                             src="./assets/design/creditcard.jpg" alt=""/><br>
                        <img class="paypal" src="./assets/design/a-g-pay.png" alt=""><br>
                        <img class="paypal" src="./assets/design/wero.png" alt="" style="width:100px;">
                        <p class="txt">sowie<br>Rechnung, Lastschrift<br>und Vorauszahlung</p></div>
                    <img src="./assets/design/logo_foot.png" class="foot-logo" alt=""/></div>
            </div>
        </div>
    </div>

    <div class="container-iw is-flex is-align-items-end is-justify-content-end">
        <a href="https://www.indenware.de" target="_blank" class=" mx-1">
            <img src="/assets/design/iw-logo.svg" width="80" height="12" alt="Shopsystem by IndenWare GmbH"/>
        </a>
        <p class="txt is-size-7" style="margin-bottom: 2px;">Shopsystem v20261012</p>
    </div>

</footer>

<div *ngIf="showModalLoginRegister" class="modal is-active">
    <div id="registration-login-content"
         role="region"
         aria-labelledby="modal-title">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Anmelden / Registrieren</p>
            <button class="delete" aria-label="Fenster schließen" (click)="toggleLoginRegister()"></button>
        </header>
        <section class="modal-card-body">
            <article *ngIf="modalLoginRegisterMessage" class="message is-warning">
                <div class="message-body">
                    {{ modalLoginRegisterMessage }}
                </div>
            </article>
            <div class="container-login">
                <iw-shop-user-login (onClickLostPasswordLink)="showModalLoginRegister = false"
                                    (onLoginSuccess)="setLoginSuccess(); setHello()"></iw-shop-user-login>
            </div>
            <div class="container-register mt-6">
                <div [ngClass]="showRegisterComponent ? 'is-hidden' : ''">
                    <p class="subtitle new-customer"><b>Ich bin Neukunde</b></p>
                    <p>Erstellen Sie ein neues Kundenkonto. </p>
                    <div class="has-text-right">
                        <button (click)="showRegisterComponent = true" class="button is-primary">Weiter</button>
                    </div>
                </div>
                <div class="register-component" [ngClass]="showRegisterComponent ? '' : 'is-hidden'">
                    <iw-shop-customer-register
                            (onRegisterSuccess)="setRegisterSuccess(); setLoginSuccess();"></iw-shop-customer-register>
                </div>
            </div>
        </section>
    </div>
    </div>
</div>

